import React, { HTMLProps, RefObject, useCallback, useEffect, useState } from 'react'
import api from '../utils/api'

interface ImageProps extends HTMLProps<HTMLImageElement> {
  slug?: string
  imageId?: number
  src?: string
  alt: string
  imageRef?: RefObject<HTMLImageElement>
}

const Image = ({ slug, imageId, alt, src, imageRef, ...props }: ImageProps) => {
    const [image, setImage] = useState<string | null>(null)
    const fetchImage = useCallback(async () => {
        let url = '/wp-json/wp/v2/media'
        if (slug) {
            url += `?slug=${slug}`
        } else if (imageId) {
            url += `/${imageId}`
        }
        return api.get(url).then(({ data }) => {
            return Array.isArray(data) ? data[0] : data
        })
    }, [slug])
    useEffect(() => {
        if (slug || imageId) {
            fetchImage().then((data) => {
                setImage(data['source_url'])
            })
        }
    }, [fetchImage, slug, imageId])

    return (
    // @ts-ignore
        <img src={src ?? image} {...props} alt={alt} ref={imageRef} />
    )
}

export default Image
